import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useRequestStore } from './request';

export const useCurrencyStore = defineStore('currency', () => {
    // State
    const shipping_costs = ref({});
    const shipping_limits = ref({});
    const requestStore = useRequestStore();

    // Actions
    async function fetchShippingConfig() {
        try {
            const response = await requestStore.get('config/shipping');
            shipping_costs.value = response.data.shipping_costs;
            shipping_limits.value = response.data.shipping_limits;
        } catch (error) {
            console.error('Failed to fetch shipping configuration:', error);
        }
    }

    // Call fetchShippingConfig when the store is created
    fetchShippingConfig();

    // Getters
    function format(amount, currency) {
        if (!amount && amount !== 0) return '';

        switch (currency) {
            case 'huf':
            case 'HUF': {
                return addSpacesToNumber(Math.round(amount)) + ' Ft';
            }
            case 'eur':
            case 'EUR': {
                return '€' + addSpacesToNumber(amount.toFixed(2));
            }
        }
    }

    return {
        shipping_costs,
        shipping_limits,
        fetchShippingConfig,
        format
    };
});

function addSpacesToNumber(number) {
    const parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
}
